import React from "react";
import "./Styles.module.scss";

const CircularProgress = ({ percentage }) => {
  const radius = 55; // Adjusted size to match screenshot
  const strokeWidth = 4; // Thicker progress bar
  const innerCircleRadius = radius - strokeWidth - 6; // Creates margin effect
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;
  const angle = (percentage / 100) * 360; // Angle for placing the dot
  const center = 90; // Center of the circle
  const dotRadius = 6; // Dot size

  // Calculate dot position
  const dotX = center + radius * Math.cos((angle - 90) * (Math.PI / 180));
  const dotY = center + radius * Math.sin((angle - 90) * (Math.PI / 180));

  return (
    <div className="progress-container">
      <svg width="250" height="250" viewBox="0 0 180 180">
        {/* Background Circle */}
        <circle
          cx="90"
          cy="90"
          r={innerCircleRadius}
          fill="white"
          stroke="rgba(240, 240, 240, 0.5)" // Light faded background
          strokeWidth={strokeWidth}
        />

        {/* Progress Circle with Gradient */}
        <circle
          cx="90"
          cy="90"
          r={radius}
          fill="none"
          stroke="url(#grad1)" // Apply gradient
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform="rotate(-90 90 90)" // Starts from top
          opacity="0.95"
        />

        {/* Gradient Definition for Faded Start */}
        <defs>
          <linearGradient id="grad1" x1="1" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="rgba(255, 165, 0, 0.1)" />
            <stop offset="25%" stopColor="#FFC107" />
            <stop offset="100%" stopColor="#FFA500" />
          </linearGradient>
        </defs>

        {/* Percentage Text */}
        <text x="50%" y="50%" textAnchor="middle" dy="8" className="percentage-text">
          {percentage}%
        </text>

        {/* Yellow Dot at End of Progress */}
        <circle cx={dotX} cy={dotY} r={dotRadius} fill="#FFA500" />
      </svg>
    </div>
  );
};

export default CircularProgress;
